module.exports = __webpack_public_path__ + "img/duck-hunt-min.a1cbc11c.png";